import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let AllSectionsPagThunk = createAsyncThunk(
  "section/AllSectionsPagThunk",
  async (arg, ThunkApi) => {
    let { rejectWithValue } = ThunkApi;
    try {
      let res = await axios.get(
        `/api/admin/pages/${arg?.id}/sections?page=${arg.page}&per_page=4`
      );
      // console.log(res.data);
      return res.data;
    } catch (error) {
      // console.log(error.response.data);
      return rejectWithValue(error.response.data);
    }
  }
);
